// extracted by mini-css-extract-plugin
module.exports = {"brainHealthStudioContent":"brainHealthStudio_brainHealthStudioContent__2doav"};